"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = QuoteClosedFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function QuoteClosedFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "quote-closed-fill"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.934,55.109a15.546,15.546,0,0,1-.241,2.092,20.539,20.539,0,0,1-3.679,8.246,37.327,37.327,0,0,1-7.313,7.5l-.036.028a2.531,2.531,0,0,0,2.166,4.444A45.017,45.017,0,0,0,72.38,72.979,32.7,32.7,0,0,0,88.887,50.244a38.164,38.164,0,0,0,.735-7.729,36.829,36.829,0,0,0-.222-3.964c-.072-.673-.164-1.349-.29-2.059-.058-.348-.132-.718-.215-1.094l-.145-.6-.1-.348-.055-.186-.119-.326c-.008-.018-.019-.034-.027-.052A17.495,17.495,0,1,0,69.934,55.109Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.68,55.109a15.55,15.55,0,0,1-.242,2.092,20.525,20.525,0,0,1-3.679,8.246,37.3,37.3,0,0,1-7.313,7.5l-.035.028a2.531,2.531,0,0,0,2.166,4.444,45.011,45.011,0,0,0,11.548-4.438,33.34,33.34,0,0,0,10.413-8.955,33.542,33.542,0,0,0,6.094-13.78,38.158,38.158,0,0,0,.736-7.729,37.35,37.35,0,0,0-.222-3.964c-.072-.673-.165-1.349-.29-2.059-.058-.348-.133-.718-.215-1.094l-.145-.6-.1-.348-.056-.186-.118-.326c-.009-.018-.019-.034-.027-.053A17.5,17.5,0,1,0,25.68,55.109Z"
  }))));
}